/** 08 §10 audio constants — client config, not `sim/`. Transcribed verbatim. */
export const AUDIO_MAX_VOICES = 24
export const AUDIO_MAX_VOICES_REDUCED = 12
export const AUDIO_VOICE_POOL = 32
export const AUDIO_PAN_WIDTH = 0.9
export const AUDIO_REF_DIST = 10
export const AUDIO_MIN_DIST_GAIN = 0.35
export const AUDIO_FAR_LPF_HZ = 6000
export const AUDIO_NEAR_LPF_HZ = 18000
export const AUDIO_LOOP_FADE_MS = 40
export const AUDIO_STEAL_FADE_MS = 8
export const AUDIO_REVERB_SEND = 0.12
export const AUDIO_VOICE_DUCK_DB = -6
export const AUDIO_DUCK_ATTACK_MS = 30
export const AUDIO_DUCK_RELEASE_MS = 300
export const AUDIO_MUSIC_BPM = 96
export const AUDIO_BEAT_S = 60 / AUDIO_MUSIC_BPM // 0.625
export const AUDIO_STEM_BARS = 8
export const AUDIO_STEM_LEN_S = AUDIO_STEM_BARS * 4 * AUDIO_BEAT_S // 20.0
export const AUDIO_STEM_XFADE_MS = 400
export const AUDIO_FLIGHT_RATE_BASE = 0.85
export const AUDIO_FLIGHT_RATE_SPAN = 0.3
export const AUDIO_STRIDE_M = 0.55
export const AUDIO_PILEUP_WINDOW_MS = 100
export const AUDIO_PILEUP_ATTEN_DB = -9
export const AUDIO_DEREZ_LOCAL_LPF_MS = 400
export const AUDIO_BLUR_FADE_MS = 100
export const AUDIO_BUDGET_KB = 3500
export const AUDIO_ONESHOT_MAX_S = 1.0
export const AUDIO_ONESHOT_LONG_MAX_S = 1.5
export const AUDIO_ROUND_END_DUCK_DB = -12
export const AUDIO_BUS_RAMP_S = 0.02

/** 08 §2 default bus gains. */
export const AUDIO_BUS_DEFAULTS = { master: 0.9, sfx: 0.8, music: 0.5, ui: 0.7, voice: 0.8 } as const
export const dbToGain = (db: number): number => Math.pow(10, db / 20)
/** 08 §2: options 0..1 → perceptual gain. */
export const optionToGain = (v: number): number => Math.max(0, Math.min(1, v)) ** 2
